// html2canvas cannot rasterise `filter: blur()`, so the share card's letterbox
// fill must be an image that is ALREADY blurred. Downscaling to a few dozen
// pixels and scaling back up with smoothing is a genuine low-pass filter, and
// the result is a plain <img> that html2canvas handles perfectly.
//
// Progress photos are base64 data URLs held in memory, so this never touches
// the network and cannot taint the canvas.

const SMALL_W = 32;   // the actual blur radius control — smaller is blurrier
const OUT_W = 256;    // big enough that upscaling in CSS stays smooth

export function makeBlurredBackdrop(src) {
  if (!src) return Promise.resolve(null);

  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = () => {
      try {
        const ratio = img.naturalHeight / img.naturalWidth || 1;

        const small = document.createElement('canvas');
        small.width = SMALL_W;
        small.height = Math.max(1, Math.round(SMALL_W * ratio));
        const sctx = small.getContext('2d');
        sctx.imageSmoothingEnabled = true;
        sctx.drawImage(img, 0, 0, small.width, small.height);

        const out = document.createElement('canvas');
        out.width = OUT_W;
        out.height = Math.max(1, Math.round(OUT_W * ratio));
        const octx = out.getContext('2d');
        octx.imageSmoothingEnabled = true;
        octx.imageSmoothingQuality = 'high';
        octx.drawImage(small, 0, 0, out.width, out.height);

        resolve(out.toDataURL('image/jpeg', 0.7));
      } catch {
        resolve(null);
      }
    };

    img.onerror = () => resolve(null);
    img.src = src;
  });
}
